<template>
  <div class="col-span-6">
    <label for="field.label" class="block text-sm font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input type="text" @change="updateValue(field.key, $event.target.value)" class="mt-1 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"/>
    </div>
    <p v-if="validation !== undefined" class="mt-2 text-sm text-red-600" id="email-error">* {{validation.msg}}</p>
  </div>
</template>

<script>
export default {
  name: 'text-field',
  props: {
    field: {
      type: Object,
      required: true
    },
    validation: {
      type: Object,
      required: false
    }
  },
  watch: {
  },
  methods: {
    updateValue(key, value) {
      this.$parent.updateValue(key, value)
    }
  }
}
</script>
